// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Cancellation24Hours24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Cancellation24Hours24Circle: FC<Cancellation24Hours24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="33"
        >
            <path
                d="M16 .5c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16S7.163.5 16 .5Zm0 6a9.74 9.74 0 0 0-3.9.787 10.1 10.1 0 0 0-3.175 2.138A10.1 10.1 0 0 0 6.787 12.6 9.74 9.74 0 0 0 6 16.5a9.74 9.74 0 0 0 .787 3.9 10.1 10.1 0 0 0 2.138 3.175 10.1 10.1 0 0 0 3.175 2.138 9.74 9.74 0 0 0 3.9.787v-2c-2.233 0-4.125-.775-5.675-2.325C8.775 20.625 8 18.733 8 16.5c0-2.233.775-4.125 2.325-5.675C11.875 9.275 13.767 8.5 16 8.5v-2Zm3.25 17c-.35 0-.646.12-.888.362a1.207 1.207 0 0 0-.362.888c0 .35.12.646.362.888.242.241.538.362.888.362s.646-.12.888-.362c.241-.242.362-.538.362-.888s-.12-.646-.362-.888a1.207 1.207 0 0 0-.888-.362Zm4-3.5c-.35 0-.646.12-.888.362a1.207 1.207 0 0 0-.362.888c0 .35.12.646.362.888.242.241.538.362.888.362s.646-.12.888-.362c.241-.242.362-.538.362-.888s-.12-.646-.362-.888A1.207 1.207 0 0 0 23.25 20ZM15 11.5v5.4l4.3 4.3 1.4-1.4-3.7-3.7v-4.6h-2Zm9.75 3.75c-.35 0-.646.12-.888.362a1.207 1.207 0 0 0-.362.888c0 .35.12.646.362.888.242.241.538.362.888.362s.646-.12.888-.362c.241-.242.362-.538.362-.888s-.12-.646-.362-.888a1.207 1.207 0 0 0-.888-.362Zm-1.5-4.75c-.35 0-.646.12-.888.362a1.207 1.207 0 0 0-.362.888c0 .35.12.646.362.888.242.241.538.362.888.362s.646-.12.888-.362c.241-.242.362-.538.362-.888s-.12-.646-.362-.888a1.207 1.207 0 0 0-.888-.362Zm-4-3.5c-.35 0-.646.12-.888.362A1.207 1.207 0 0 0 18 8.25c0 .35.12.646.362.888.242.241.538.362.888.362s.646-.12.888-.362c.241-.242.362-.538.362-.888s-.12-.646-.362-.888A1.207 1.207 0 0 0 19.25 7Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Cancellation24Hours24Circle;
